export enum EInsightsIAAnalysisType {
  Vertical = "vertical",
  Horizontal = "horizontal"
}

export type TInsightsIASeverity = "Critical" | "Warning" | "Infos";

export interface IInsightsIAOption {
  label: string;
  value: string;
  disabled?: boolean;
}

export interface IInsightsIAAnalysisOption extends IInsightsIAOption {
  value: EInsightsIAAnalysisType;
  tag?: string;
}

export interface IInsightsIASummaryItem {
  label: string;
  value: number;
  icon: string;
  severity: TInsightsIASeverity;
}
